import React, { Component } from "react";
import LanguageSelector from "components/languageSelector";
import { connect } from "react-redux";
import "./header.css";
import { PseudoContent } from "components/pseudoContent";

class Header extends Component {
  state = {};

  render() {
    return (
      <PseudoContent>
        <div className="pageHeader">
          <div className="row">
            <div className="col-8">
              <div className="pageHeaderLogo"></div>
            </div>
            <div className="col-4">{<LanguageSelector />}</div>
          </div>
          <div className="pageHeaderText no-before"></div>
        </div>
      </PseudoContent>
    );
  }
}

const mapStateToProps = (state) => ({ i18n: state.i18n });
export default connect(mapStateToProps)(Header);
